import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DashboardState } from './dashboard.state';

export const selectDashboardState = createFeatureSelector<DashboardState>('adminDashboard');

export const selectDashboardOverview = createSelector(
  selectDashboardState,
  (state) => state.overview,
);

export const selectDashboardLoading = createSelector(
  selectDashboardState,
  (state) => state.loading,
);

export const selectDashboardError = createSelector(
  selectDashboardState,
  (state) => state.error,
);

export const selectUserStats = createSelector(
  selectDashboardState,
  (state) => state.userStats,
);

export const selectUserStatsLoading = createSelector(
  selectDashboardState,
  (state) => state.userStatsLoading,
);

export const selectUserStatsError = createSelector(
  selectDashboardState,
  (state) => state.userStatsError,
);

export const selectEventStats = createSelector(
  selectDashboardState,
  (state) => state.eventStats,
);

export const selectEventStatsLoading = createSelector(
  selectDashboardState,
  (state) => state.eventStatsLoading,
);

export const selectEventStatsError = createSelector(
  selectDashboardState,
  (state) => state.eventStatsError,
);

export const selectVolunteerStats = createSelector(
  selectDashboardState,
  (state) => state.volunteerStats,
);

export const selectVolunteerStatsLoading = createSelector(
  selectDashboardState,
  (state) => state.volunteerStatsLoading,
);

export const selectVolunteerStatsError = createSelector(
  selectDashboardState,
  (state) => state.volunteerStatsError,
);
